import React from 'react';

const Footer = () => {
    const year = new Date().getFullYear().toString();
    return (
        <footer className="navbar footer justify-content-center">
            <div className="row">
                <div className="col-12 text-center">
                    <span className="navbar-text">&copy; Matthew Dove {year}</span>
                </div>
            </ div>
        </footer>
    );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/Footer.js